var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('section',{staticClass:"lock"},[_c('ms-loading',{attrs:{"size":'large',"justify":true}})],1):_c('section',[_vm._v("isready false")])}
var staticRenderFns = []

export { render, staticRenderFns }